import Button from "@pathwright/ui/src/components/button/Button"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"

const AudioPlayer = ({ src, autoPlay, preload, onPlay, download }) => (
  <div>
    <audio
      autoPlay={autoPlay}
      preload={preload}
      onPlay={onPlay}
      src={src}
      controlslist="nodownload"
      controls={true}
    />
    {download && (
      <Button styleType="tertiary" href={src} download={true} target="_blank">
        <Pathicon icon="download" />
        Download audio
      </Button>
    )}
  </div>
)

AudioPlayer.displayName = "AudioPlayer"

AudioPlayer.defaultProps = {
  autoplay: false,
  preload: "metadata",
  download: true
}

export default AudioPlayer
